import type { FC } from 'react';
import { FormField, InputText, Select } from '@reverse-hr/design-system';
import { LANG_OPTIONS } from '@components/ShareLinkModal/_constants/ShareLinkModal.constants';
import { useTranslation } from 'react-i18next';
import type { TShareLinkModalFormFieldsProps } from '@components/ShareLinkModal/ShareLinkModal.types';

export const ShareLinkModalFormFields: FC<
  TShareLinkModalFormFieldsProps
> = props => {
  const { validationErrors, formData, onChange, getEmailHint } = props;

  const { t } = useTranslation('', {
    keyPrefix: 'modal.share',
  });

  return (
    <>
      <div className="rev-u-px-16 rev-u-py-8 rev-o-col-12 rev-o-col--medium-6">
        <FormField
          label={t('inputs.first_name.label')}
          isRequired
          error={validationErrors.clientFirstName}
        >
          <InputText
            name="firstName"
            id="firstName"
            placeholder={t('inputs.first_name.placeholder')}
            isResponsive
            value={formData.clientFirstName}
            onChange={event =>
              onChange({
                name: 'clientFirstName',
                value: event,
                valid: true,
              })
            }
            hasErrors={!!validationErrors.clientFirstName}
          />
        </FormField>
      </div>
      <div className="rev-u-px-16 rev-u-py-8 rev-o-col-12 rev-o-col--medium-6">
        <FormField
          label={t('inputs.last_name.label')}
          isRequired
          error={validationErrors.clientLastName}
        >
          <InputText
            name="lastName"
            id="lastName"
            placeholder={t('inputs.last_name.placeholder')}
            isResponsive
            value={formData.clientLastName}
            onChange={event =>
              onChange({
                name: 'clientLastName',
                value: event,
                valid: true,
              })
            }
            hasErrors={!!validationErrors.clientLastName}
          />
        </FormField>
      </div>
      <div className="rev-u-px-16 rev-u-py-8 rev-o-col-12 rev-o-col--medium-6">
        <FormField
          label={t('inputs.email.label')}
          isRequired
          error={validationErrors.clientEmail}
          hint={getEmailHint()}
        >
          <InputText
            name="email"
            id="email"
            placeholder={t('inputs.email.placeholder')}
            isResponsive
            value={formData.clientEmail}
            onChange={event =>
              onChange({
                name: 'clientEmail',
                value: event,
                valid: true,
              })
            }
            hasErrors={!!validationErrors.clientEmail}
          />
        </FormField>
      </div>
      <div className="rev-u-px-16 rev-u-py-8 rev-o-col-12 rev-o-col--medium-6">
        <FormField
          label={t('inputs.lang.label')}
          isRequired
          error={validationErrors.language}
        >
          <Select
            name="lang"
            id="lang"
            placeholder={t('inputs.lang.placeholder')}
            isResponsive
            value={formData.language}
            onChange={event =>
              onChange({
                name: 'language',
                value: event.value as string,
                valid: true,
              })
            }
            options={LANG_OPTIONS}
          />
        </FormField>
      </div>
    </>
  );
};
